
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_PEOPLE } from '../data/GET_PEOPLE';

function usePeopleSearch() {
    const navigate = useNavigate();
    const location = useLocation();
    const [search, setSearch] = useState(
        () => new URLSearchParams(location.search).get('search') || ''
    );
    const [hasSearched, setHasSearched] = useState(false);
    const { loading, error, data, refetch } = useQuery(GET_PEOPLE, { variables: { search } });
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    const handleSearchChange = useCallback((_: any, change: any) => {
        if (!hasSearched) setHasSearched(true);
        clearTimeout(timeoutRef.current);
        setSearch(change.value);
        timeoutRef.current = setTimeout(() => {
            navigate({ pathname: location.pathname, search: `?search=${change.value}` });
            refetch({ search: change.value });
        }, 500);
    }, [refetch, hasSearched, navigate, location.pathname]);

    // Sync state with URL on browser back/forward
    useEffect(() => {
        const param = new URLSearchParams(location.search).get('search');
        if (param === null) {
            setSearch('');
            setHasSearched(false);
            refetch({ search: '' });
        } else if (param !== search) {
            setSearch(param);
            setHasSearched(true);
            refetch({ search: param });
        }
    }, [location.search, refetch]);

    const shouldShowSearch =
        (data?.users.length > 10) || search.length > 0 || hasSearched;

    return { search, loading, error, data, handleSearchChange, shouldShowSearch };
}

export { usePeopleSearch };
